import React from "react";
import ImplementContainer from "../../containers/Implement";

const ImplementScreen = () => {
  return <ImplementContainer />;
};

export default ImplementScreen;
